
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("a7YYz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0d8ed10595d291bf$export$2e2bcd8739ae039);

var $iDwZs = parcelRequire("iDwZs");
var $0d8ed10595d291bf$export$2e2bcd8739ae039 = (0, $iDwZs.default);

});
parcelRegister("iDwZs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $384683bb4aa2f774$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $kJlBc = parcelRequire("kJlBc");

var $jK1pm = parcelRequire("jK1pm");

var $99tbx = parcelRequire("99tbx");

var $bHrSR = parcelRequire("bHrSR");

var $5n5ys = parcelRequire("5n5ys");
const $384683bb4aa2f774$var$NotFoundErrorPage = ()=>{
    const { push: push } = (0, $kJlBc.useRouterActions)();
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const onButtonClick = (0, $eUqFw.useCallback)(()=>push('/jira'), [
        push
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "not-found-error-page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bHrSR.ErrorPage), {
        header: formatMessage((0, $5n5ys.default).header),
        description: formatMessage((0, $5n5ys.default).description, {
            br: '{br}'
        }),
        buttonMessage: formatMessage((0, $5n5ys.default).primaryButton),
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($99tbx))),
        errorCode: "404",
        onButtonClick: onButtonClick,
        error: null
    }));
};
var $384683bb4aa2f774$export$2e2bcd8739ae039 = $384683bb4aa2f774$var$NotFoundErrorPage;

});
parcelRegister("jK1pm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6f009785aaee067$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7rh0R = parcelRequire("7rh0R");

var $iWLL0 = parcelRequire("iWLL0");

var $5iuyH = parcelRequire("5iuyH");

var $fVaJL = parcelRequire("fVaJL");

var $232mI = parcelRequire("232mI");
/** A portion of the page we apply measurement to */ function $f6f009785aaee067$var$JiraUFOSegmentWrapper({ children: children }) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const interactionContext = (0, $5iuyH.useInteractionContext)();
    const relayProfilerContext = (0, $eUqFw.useMemo)(()=>({
            getInteractionContext: ()=>interactionContext,
            wrapPrepareQueryResource (cb) {
                return cb();
            },
            retainQuery (info) {
                this.getInteractionContext().retainQuery(info);
            }
        }), [
        interactionContext
    ]);
    const reactLooselyLazyContext = (0, $eUqFw.useMemo)(()=>{
        const moduleLoadingRequests = {};
        return {
            current: {
                getInteractionContext () {
                    return interactionContext;
                },
                onPreload (moduleId, _priority) {
                    this.getInteractionContext().addPreload((0, $fVaJL.extractModuleName)(moduleId), performance.now());
                },
                onLoadStart (info) {
                    const timeoutId = setTimeout(()=>{
                        delete moduleLoadingRequests[info.identifier];
                    }, 30000);
                    const request = {
                        start: performance.now(),
                        timeoutId: timeoutId
                    };
                    moduleLoadingRequests[info.identifier] = request;
                },
                onLoadComplete (info) {
                    const request = moduleLoadingRequests[info.identifier];
                    if (request) {
                        clearTimeout(request.timeoutId);
                        delete moduleLoadingRequests[info.identifier];
                        this.getInteractionContext()?.addLoad((0, $fVaJL.extractModuleName)(info.identifier), request.start, performance.now());
                    }
                },
                placeholderFallBackMounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().addHoldByID(this.getInteractionContext().labelStack, id, name);
                },
                placeholderFallBackUnmounted (id, name, lazyWait) {
                    if (lazyWait) return;
                    this.getInteractionContext().removeHoldByID(this.getInteractionContext().labelStack, id, name);
                }
            }
        };
    }, [
        interactionContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iWLL0.ProfilerContext).Provider, {
        value: relayProfilerContext
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7rh0R.ProfilerContext).Provider, {
        value: reactLooselyLazyContext
    }, children));
}
function $f6f009785aaee067$export$2e2bcd8739ae039({ name: segmentName, children: children }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $232mI.default), {
        name: segmentName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f6f009785aaee067$var$JiraUFOSegmentWrapper, null, children));
}

});

parcelRegister("99tbx", function(module, exports) {
module.exports = new URL("not-found.52011569.svg", import.meta.url).toString();

});

parcelRegister("bHrSR", function(module, exports) {

$parcel$export(module.exports, "ErrorPage", () => $4ca36a50b3afce4f$export$c120a0e80fd44ca6);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $7u4fN = parcelRequire("7u4fN");

var $hI5oG = parcelRequire("hI5oG");

var $b5IAe = parcelRequire("b5IAe");
var $1ZAYh = parcelRequire("1ZAYh");

var $aYtGv = parcelRequire("aYtGv");

var $c9TLT = parcelRequire("c9TLT");

var $ihlUj = parcelRequire("ihlUj");

var $5JgJ2 = parcelRequire("5JgJ2");

var $iJHZm = parcelRequire("iJHZm");

var $3NfZx = parcelRequire("3NfZx");
const $4ca36a50b3afce4f$export$c120a0e80fd44ca6 = ({ header: header, description: description, buttonMessage: buttonMessage, imageUrl: imageUrl, linkMessage: linkMessage, linkHref: linkHref, errorCode: errorCode, onButtonClick: onButtonClick, error: error })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca36a50b3afce4f$var$WindowContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca36a50b3afce4f$var$ContentContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        size: "large",
        as: "p",
        testId: "error-pages.common.ui.error-heading"
    }, header), description.split('{br}').map((p, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca36a50b3afce4f$var$Text, {
            key: i,
            "data-testid": `error-pages.common.ui.error-description${i}`
        }, p)), Boolean(linkMessage) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
        href: linkHref,
        "data-testid": "error-pages.common.ui.error-link"
    }, linkMessage), Boolean(errorCode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca36a50b3afce4f$var$ErrorCode, null, formatMessage((0, $3NfZx.default).errorCode, {
        errorCode: errorCode
    })), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ihlUj.ErrorHash), {
        error: error
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b5IAe.default), {
        xcss: $4ca36a50b3afce4f$var$buttonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7u4fN.default), {
        appearance: "primary",
        onClick: onButtonClick,
        testId: "error-pages.common.ui.error-button"
    }, buttonMessage))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca36a50b3afce4f$var$Image, {
        src: imageUrl,
        alt: ""
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iJHZm.SpaStatePageErrorReady), null));
};
const $4ca36a50b3afce4f$var$ErrorCode = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ca36a50b3afce4f$var$ErrorCodeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hI5oG.default), {
        level: "h200",
        as: "p",
        testId: "error-pages.common.ui.error-code"
    }, children));
const $4ca36a50b3afce4f$var$imageHeight = (0, $c9TLT.gridSize) / 2 * 45; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ca36a50b3afce4f$var$WindowContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1s93bfy": (0, $9t7rW.default)((0, $aYtGv.PAGE_LAYOUT_OFFSET_TOP))
        },
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _4t3i1l47",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ca36a50b3afce4f$var$ContentContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsbpl2w _p12f1vuk _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $4ca36a50b3afce4f$var$Image = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3imgvx _p12fmgvx _18u0xy5q _1e0c1ule",
            __cmplp.className
        ])
    });
});
const $4ca36a50b3afce4f$var$Text = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qpxbi _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $4ca36a50b3afce4f$var$buttonWrapperStyles = (0, $1ZAYh.xcss)({
    paddingTop: 'space.400'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ca36a50b3afce4f$var$ErrorCodeWrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qpxbi _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aYtGv", function(module, exports) {

$parcel$export(module.exports, "PAGE_LAYOUT_OFFSET_TOP", () => $479507d87baa6502$export$d60454526e2281af);
$parcel$export(module.exports, "HORIZONTAL_GLOBAL_NAV_HEIGHT", () => $479507d87baa6502$export$30fa7cc5f2690a43);
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// eslint-disable-next-line jira/restricted/@atlaskit+page-layout

var $ho1Ek = parcelRequire("ho1Ek");
const $479507d87baa6502$export$d60454526e2281af = `(${(0, $ho1Ek.TOP_NAVIGATION_HEIGHT)} + ${(0, $ho1Ek.BANNER_HEIGHT)})`;
const $479507d87baa6502$export$30fa7cc5f2690a43 = 56;

});

parcelRegister("c9TLT", function(module, exports) {

$parcel$export(module.exports, "gridSize", () => $d7c0be4143e494a4$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "borderRadius", () => $d7c0be4143e494a4$export$7a57f79000377ca2);
$parcel$export(module.exports, "fontSize", () => $d7c0be4143e494a4$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fontFamily", () => $d7c0be4143e494a4$export$a5975749f0374264);
$parcel$export(module.exports, "codeFontFamily", () => $d7c0be4143e494a4$export$356129969ee49c55);
$parcel$export(module.exports, "contentHorizontalSpacing", () => $d7c0be4143e494a4$export$22dec01f2c854397);
$parcel$export(module.exports, "layers", () => $d7c0be4143e494a4$export$7be255094ccdc533);
$parcel$export(module.exports, "layout", () => $d7c0be4143e494a4$export$b3219800bda33a1f);

var $lcnyw = parcelRequire("lcnyw");
const $d7c0be4143e494a4$export$6d8204c2cb2e06b8 = (0, $lcnyw.gridSize)();
const $d7c0be4143e494a4$export$7a57f79000377ca2 = (0, $lcnyw.borderRadius)();
const $d7c0be4143e494a4$export$85e3c3ca0c6fb93 = (0, $lcnyw.fontSize)();
const $d7c0be4143e494a4$export$a5975749f0374264 = (0, $lcnyw.fontFamily)();
const $d7c0be4143e494a4$export$356129969ee49c55 = (0, $lcnyw.codeFontFamily)();
const $d7c0be4143e494a4$export$22dec01f2c854397 = 40;
const $d7c0be4143e494a4$export$dab5ea164c6f81a = 100;
const $d7c0be4143e494a4$export$7be255094ccdc533 = {
    banner: (0, $lcnyw.layers).navigation(),
    card: (0, $lcnyw.layers).card(),
    dialog: (0, $lcnyw.layers).dialog(),
    navigation: (0, $lcnyw.layers).navigation(),
    // left sidebar overrides the bottom shadow of navigation without this
    leftSidebar: (0, $lcnyw.layers).navigation() - 1,
    // right sidebar shows on top of navigation elements without this
    rightSidebar: (0, $lcnyw.layers).navigation() - 1,
    layer: (0, $lcnyw.layers).layer(),
    blanket: (0, $lcnyw.layers).blanket(),
    modal: (0, $lcnyw.layers).modal(),
    flag: (0, $lcnyw.layers).flag(),
    spotlight: (0, $lcnyw.layers).spotlight(),
    tooltip: (0, $lcnyw.layers).tooltip(),
    mobileBanner: $d7c0be4143e494a4$export$dab5ea164c6f81a
};
const $d7c0be4143e494a4$export$b3219800bda33a1f = {
    issueIconSize: $d7c0be4143e494a4$export$6d8204c2cb2e06b8 * 2
};

});

parcelRegister("ihlUj", function(module, exports) {

$parcel$export(module.exports, "ErrorHash", () => $e823e2ae3cb86cca$export$db1607d938d7ca33);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $iH6c1 = parcelRequire("iH6c1");
const $e823e2ae3cb86cca$export$db1607d938d7ca33 = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        "data-testid": "errors-handling.ui.error-hash"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($e823e2ae3cb86cca$var$Wrapper, null, "ERROR: ", (0, $iH6c1.getErrorHash)(error)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e823e2ae3cb86cca$var$Wrapper = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "code", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _18s8qssn _1yt4u49m _bfhk1s10 _2rko1l7b _ect485st _1wyb16xt _syaz1wmz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iJHZm", function(module, exports) {

$parcel$export(module.exports, "SpaStateContainer", () => $a6f32366b1daf5c0$export$e9a92b877fe80e80);
$parcel$export(module.exports, "SpaStateAppStart", () => $a6f32366b1daf5c0$export$d18dd27183a635c);
$parcel$export(module.exports, "SpaStateAppStartWithMatchCheck", () => $a6f32366b1daf5c0$export$95a2912d76fb5433);
$parcel$export(module.exports, "SpaStatePageReady", () => $a6f32366b1daf5c0$export$c34439f945fccbdf);
$parcel$export(module.exports, "SpaStatePageReadyOnUpdate", () => $a6f32366b1daf5c0$export$41e70078eeddaddc);
$parcel$export(module.exports, "SpaStatePageErrorReady", () => $a6f32366b1daf5c0$export$2583aa269898885c);
$parcel$export(module.exports, "getSpaStateLastUserLocation", () => $a6f32366b1daf5c0$export$6e9ab893e97cccef);

var $eUqFw = parcelRequire("eUqFw");

var $heB5U = parcelRequire("heB5U");
var $ggKAj = parcelRequire("ggKAj");
var $gasA1 = parcelRequire("gasA1");

var $3viaK = parcelRequire("3viaK");

var $kJlBc = parcelRequire("kJlBc");

var $lcJyp = parcelRequire("lcJyp");

var $cfLkw = parcelRequire("cfLkw");
const $a6f32366b1daf5c0$export$e9a92b877fe80e80 = (0, $heB5U.createContainer)((0, $cfLkw.default));
const $a6f32366b1daf5c0$export$d18dd27183a635c = ()=>{
    const startRef = (0, $eUqFw.useRef)(Date.now());
    const [{ visitedPages: visitedPages }, { setAppStart: setAppStart }] = (0, $lcJyp.useSpaState)();
    (0, $eUqFw.useMemo)(()=>{
        startRef.current = Date.now();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        visitedPages
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        setAppStart(startRef.current);
    }, [
        setAppStart,
        visitedPages
    ]);
    return null;
};
const $a6f32366b1daf5c0$var$useRouterMatchSelector = (0, $kJlBc.createRouterSelector)((state)=>state.match);
const $a6f32366b1daf5c0$var$useSpaStatePagesCount = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: ({ visitedPages: visitedPages })=>visitedPages.length
});
const $a6f32366b1daf5c0$export$95a2912d76fb5433 = ()=>{
    const match = $a6f32366b1daf5c0$var$useRouterMatchSelector();
    const [count, { setAppStart: setAppStart }] = $a6f32366b1daf5c0$var$useSpaStatePagesCount();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($a6f32366b1daf5c0$export$ada7e0ec445851a2, {
        visitedPagesLength: count,
        onSetAppStart: setAppStart,
        match: match
    });
};
const $a6f32366b1daf5c0$export$c34439f945fccbdf = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady
        }));
const $a6f32366b1daf5c0$export$41e70078eeddaddc = ({ comparer: comparer } /* TODO - this should be using only the actions subscriber not state+actions subscriber */ )=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppReady: setAppReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppReady,
            args: comparer
        }));
const $a6f32366b1daf5c0$export$2583aa269898885c = ()=>/* TODO - this should be using only the actions subscriber not state+actions subscriber */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lcJyp.SpaStateSubscriber), null, (_, { setAppErrorReady: setAppErrorReady })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3viaK.default), {
            op: setAppErrorReady
        }));
class $a6f32366b1daf5c0$export$ada7e0ec445851a2 extends (0, $eUqFw.Component) {
    static getDerivedStateFromProps(props, state) {
        const visitedPageLengthHasChanged = props.visitedPagesLength !== state.visitedPagesLength;
        const matchHasChanged = props.match !== state.match;
        const setAppStart = !state.started || visitedPageLengthHasChanged && matchHasChanged;
        if (setAppStart) props.onSetAppStart(Date.now());
        // On transition visitedPageLength will always change before match, the only exception is when there is page
        // ids (e.g. issue types). When redirecting, the length doesn't change while the match changes (from issuetype to issuetype/xxxxx).
        // so if match changed without visitedPageLength changing, cache the new match and wait for both to update.
        if (setAppStart || !visitedPageLengthHasChanged) return {
            started: true,
            visitedPagesLength: props.visitedPagesLength,
            match: props.match
        };
        // if visitedPageLength changed, ignore and wait for update in match (which will trigger setAppStart next)
        return state;
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args);
        /** so the challenge we are facing is that, we need to reset page when there's a visitedPagesLength change and a route change,
	 * but they don't always happen at the the same time during the current spa router situation. The following code does this:
	 *
	 * if first render: set app start
	 *
	 * if subsequently render with only visitedPagesLength change, ignore this updates, cache the old visitedPagesLength,
	 * wait for incoming match change
	 *
	 * if subsequently render with only match change, ignore this updates, cache the old match, wait for incoming
	 * visitedPagesLength change
	 *
	 *  if incoming changes contain both route and length change, we update state and start app
	 *
	 */ this.state = {
            visitedPagesLength: 0,
            started: false,
            match: null
        };
    }
}
const $a6f32366b1daf5c0$export$6e9ab893e97cccef = ()=>{
    const { visitedPages: visitedPages } = (0, $gasA1.defaultRegistry).getStore((0, $cfLkw.default)).storeState.getState();
    return visitedPages.length ? visitedPages[visitedPages.length - 1].userLocation : '';
};

});
parcelRegister("3viaK", function(module, exports) {

$parcel$export(module.exports, "default", () => $114bcd9b637bc682$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hTLlD = parcelRequire("hTLlD");
// eslint-disable-next-line jira/react/no-class-components
class $114bcd9b637bc682$var$OpTrigger extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = {
            args: []
        };
    }
    componentDidMount() {
        this.props.op(...this.props.args);
    }
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hTLlD)))(this.props.args, nextProps.args);
    }
    componentDidUpdate() {
        this.props.op(...this.props.args);
    }
    render() {
        return null;
    }
}
var $114bcd9b637bc682$export$2e2bcd8739ae039 = $114bcd9b637bc682$var$OpTrigger;

});

parcelRegister("lcJyp", function(module, exports) {

$parcel$export(module.exports, "SpaStateSubscriber", () => $847fac6342ee5df8$export$fd52daf2a3c1ec68);
$parcel$export(module.exports, "SpaStateActionsSubscriber", () => $847fac6342ee5df8$export$3dfa91988c213fbc);
$parcel$export(module.exports, "useSpaState", () => $847fac6342ee5df8$export$a57865516f6345d1);
$parcel$export(module.exports, "useSpaStateActions", () => $847fac6342ee5df8$export$b134752525935b78);

var $ggKAj = parcelRequire("ggKAj");
var $dYfll = parcelRequire("dYfll");

var $cfLkw = parcelRequire("cfLkw");
const $847fac6342ee5df8$export$fd52daf2a3c1ec68 = (0, $dYfll.createSubscriber)((0, $cfLkw.default));
const $847fac6342ee5df8$export$3dfa91988c213fbc = (0, $dYfll.createSubscriber)((0, $cfLkw.default), {
    selector: null
});
const $847fac6342ee5df8$export$a57865516f6345d1 = (0, $ggKAj.createHook)((0, $cfLkw.default));
const $847fac6342ee5df8$export$b134752525935b78 = (0, $ggKAj.createHook)((0, $cfLkw.default), {
    selector: null
});

});
parcelRegister("cfLkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e76bb655f4dbc8c$export$2e2bcd8739ae039);

var $a61MH = parcelRequire("a61MH");

var $hompL = parcelRequire("hompL");

var $a2pDC = parcelRequire("a2pDC");
const $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a = {
    transitionCheckTimestamp: -1,
    currentPage: {
        uuid: false ? '' : (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
        startTime: typeof performance !== 'undefined' && performance.timing !== undefined && performance.timing.navigationStart || 0,
        apps: {},
        userLocation: ''
    },
    visitedPages: [],
    navigation: {
        isCollapsed: false,
        viewId: 'noView',
        viewType: '',
        projectType: null,
        isInitialEventSent: false,
        pageId: null,
        nextViewId: ''
    }
};
const $7e76bb655f4dbc8c$var$store = (0, $a61MH.createStore)({
    name: 'spa-state',
    initialState: $7e76bb655f4dbc8c$export$d4c72bab9d6cc13a,
    actions: $a2pDC
});
var $7e76bb655f4dbc8c$export$2e2bcd8739ae039 = $7e76bb655f4dbc8c$var$store;

});
parcelRegister("a2pDC", function(module, exports) {

$parcel$export(module.exports, "setAppStart", () => (parcelRequire("gKuw7")).setAppStart);
$parcel$export(module.exports, "setAppReady", () => (parcelRequire("gKuw7")).setAppReady);
$parcel$export(module.exports, "setAppStartWithAppId", () => (parcelRequire("gKuw7")).setAppStartWithAppId);
$parcel$export(module.exports, "setAppReadyWithAppId", () => (parcelRequire("gKuw7")).setAppReadyWithAppId);
$parcel$export(module.exports, "setAppErrorReady", () => (parcelRequire("gKuw7")).setAppErrorReady);
$parcel$export(module.exports, "setTimeoutReady", () => (parcelRequire("gKuw7")).setTimeoutReady);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => (parcelRequire("gKuw7")).setTimeoutReadyWithAppId);
$parcel$export(module.exports, "resetCurrentPage", () => (parcelRequire("gKuw7")).resetCurrentPage);
$parcel$export(module.exports, "setResourceMetrics", () => (parcelRequire("gKuw7")).setResourceMetrics);

var $gKuw7 = parcelRequire("gKuw7");

});
parcelRegister("gKuw7", function(module, exports) {

$parcel$export(module.exports, "resetCurrentPage", () => $1354b0144a8be88b$export$5639685a1fb81722);
$parcel$export(module.exports, "setTimeoutReadyWithAppId", () => $1354b0144a8be88b$export$8a98548dad2fa97b);
$parcel$export(module.exports, "setTimeoutReady", () => $1354b0144a8be88b$export$b9cc4378ea785421);
$parcel$export(module.exports, "setAppStartWithAppId", () => $1354b0144a8be88b$export$9d528722f2ff2999);
$parcel$export(module.exports, "setAppStart", () => $1354b0144a8be88b$export$71192061050856ad);
$parcel$export(module.exports, "setAppReadyWithAppId", () => $1354b0144a8be88b$export$6a25429a42d30f9a);
$parcel$export(module.exports, "setAppReady", () => $1354b0144a8be88b$export$fc59cc4ed9bba7cd);
$parcel$export(module.exports, "setAppErrorReady", () => $1354b0144a8be88b$export$aff63c1e41443b6a);
$parcel$export(module.exports, "setResourceMetrics", () => $1354b0144a8be88b$export$8ad155d489dcf34d);

var $hompL = parcelRequire("hompL");

var $3tabS = parcelRequire("3tabS");

var $1ybV0 = parcelRequire("1ybV0");

var $keguF = parcelRequire("keguF");

var $4nnPJ = parcelRequire("4nnPJ");

var $ULuRM = parcelRequire("ULuRM");
const $1354b0144a8be88b$export$7bd623b29ec8e1eb = 10000;
const $1354b0144a8be88b$export$5639685a1fb81722 = (nextRouteUfoName, nextRouteName)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        performance.mark('resetCurrentPage');
        (0, $3tabS.browserMetrics).startPageLoad({
            isInitial: false
        });
        (0, $ULuRM.default)(nextRouteUfoName, nextRouteName);
        if ((0, $1ybV0.ff)('uip.ufo')) {
            (0, $4nnPJ.GlobalPageLoadExperience).abort({
                force: true
            });
            (0, $4nnPJ.GlobalPageLoadExperience).startPageLoad('UNKNOWN', false);
        }
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) setState({
            currentPage: {
                uuid: (0, (/*@__PURE__*/$parcel$interopDefault($hompL))).v4(),
                apps: {},
                startTime: Date.now(),
                userLocation: ''
            },
            visitedPages: [
                ...currentState.visitedPages,
                {
                    ...currentState.currentPage
                }
            ],
            transitionCheckTimestamp: 0
        });
    };
const $1354b0144a8be88b$export$8a98548dad2fa97b = (appId, timeoutTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].timeoutTime)) {
            const apps = {
                ...currentPage.apps
            };
            if (apps[appId] && apps[appId].expectingTimeout) {
                const updatedPage = {
                    ...currentPage,
                    apps: {
                        ...apps,
                        [appId]: {
                            ...apps[appId],
                            timeoutTime: timeoutTime,
                            expectingTimeout: 0
                        }
                    }
                };
                setState({
                    currentPage: updatedPage
                });
            }
        }
    };
const $1354b0144a8be88b$export$b9cc4378ea785421 = (timeoutTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId, timeoutTime));
    };
const $1354b0144a8be88b$export$9d528722f2ff2999 = (appId, startTime = Date.now())=>({ dispatch: dispatch, getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && !(currentPage.apps[appId] && currentPage.apps[appId].startTime)) {
            const timeoutId = setTimeout(()=>{
                dispatch($1354b0144a8be88b$export$8a98548dad2fa97b(appId));
            }, $1354b0144a8be88b$export$7bd623b29ec8e1eb);
            const updatedPage = {
                ...currentPage,
                userLocation: (0, $keguF.getUserLocation)(),
                apps: {
                    ...currentPage.apps,
                    [appId]: {
                        startTime: startTime,
                        expectingTimeout: timeoutId
                    }
                }
            };
            setState({
                // @ts-expect-error - TS2322 - Type '{ userLocation: string; apps: { [x: string]: AppState | { startTime: number; expectingTimeout: NodeJS.Timeout; }; }; uuid: string; startTime: number; resources?: ResourceMetrics[] | undefined; }' is not assignable to type 'PageTiming'.
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$71192061050856ad = (startTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$9d528722f2ff2999(appId, startTime));
    };
const $1354b0144a8be88b$export$6a25429a42d30f9a = (appId, endTime = Date.now())=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps[appId] && currentPage.apps[appId].endTime === undefined) {
            const apps = {
                ...currentPage.apps
            };
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(currentPage.apps[appId].expectingTimeout);
            const updatedPage = {
                ...currentPage,
                apps: {
                    ...apps,
                    [appId]: {
                        ...apps[appId],
                        endTime: endTime,
                        expectingTimeout: 0
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$fc59cc4ed9bba7cd = (endTime = Date.now())=>({ dispatch: dispatch }, { appId: appId })=>{
        dispatch($1354b0144a8be88b$export$6a25429a42d30f9a(appId, endTime));
    };
const $1354b0144a8be88b$export$aff63c1e41443b6a = ()=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const { currentPage: currentPage } = currentState;
        if (currentPage && currentPage.apps && Object.keys(currentPage.apps).length > 0) {
            const updatedPage = {
                ...currentPage,
                apps: {
                    'error-page': {
                        endTime: Date.now()
                    }
                }
            };
            setState({
                currentPage: updatedPage
            });
        }
    };
const $1354b0144a8be88b$export$8ad155d489dcf34d = (resourceMetrics)=>({ getState: getState, setState: setState })=>{
        const currentState = getState();
        setState({
            currentPage: {
                ...currentState.currentPage,
                resources: [
                    ...currentState.currentPage.resources ? currentState.currentPage.resources : [],
                    resourceMetrics
                ]
            }
        });
    };

});





parcelRegister("3NfZx", function(module, exports) {

$parcel$export(module.exports, "default", () => $93b82484a9792d21$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $93b82484a9792d21$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    errorCode: {
        "id": "error-pages.common.error-code",
        "defaultMessage": "Error code: {errorCode}"
    }
});

});


parcelRegister("5n5ys", function(module, exports) {

$parcel$export(module.exports, "default", () => $127f2799e0a6839f$export$2e2bcd8739ae039);

var $90IgZ = parcelRequire("90IgZ");
var $127f2799e0a6839f$export$2e2bcd8739ae039 = (0, $90IgZ.defineMessages)({
    header: {
        "id": "error-pages.not-found-error-page.header",
        "defaultMessage": "We can't find the page you're looking for"
    },
    description: {
        "id": "error-pages.not-found-error-page.description",
        "defaultMessage": "Someone may've deleted it, changed its name, or it's temporarily unavailable.\n        {br}\n        Check your spelling in the address bar. Or, try opening this site's home page to search or browse for the content."
    },
    primaryButton: {
        "id": "error-pages.not-found-error-page.primary-button",
        "defaultMessage": "Go to the homepage"
    }
});

});




//# sourceMappingURL=async-error-pages-not-found.59c0a4e3.js.map
